<div *ngIf="isLoading">
  <div *appSpinner="isLoading; message: 'Please wait...'"></div>
</div>

<div class="starting" *ngIf="isStarting">
  <img src="../../../../assets/img/logomain.png" alt="" class="img">
</div>

<div *ngIf="!isStarting" class="login-page-custom">
  <div class="container-login">
    <img src="../../assets/img/logomain.png" class="img" />
    <div class="py-5 form-container">
      
      <form *ngIf="!resetPass" #loginForm="ngForm" name="loginForm">
        <div *ngIf="forgotPass" class="small-text pointer mb-3">
          <p>Enter your email and we'll send you token for reset your password!</p>
        </div>
        <div class="form-group pb-3">
          <input #userEmail="ngModel" ngModel name="userEmail" type="email" class="form-control input-underline"
            aria-describedby="emailHelp" placeholder="EMAIL" required pattern="^\S*[@]\S*[.]\S*$" [class.is-invalid]="userEmail.invalid && userEmail.touched">
        </div>
        <div *ngIf="!forgotPass" class="form-group pb-3">
          <show-hide-password icon="fa fa-eye-slash" class="inputbotom">
            <input #userPassword="ngModel" ngModel name="userPassword" type="password" (keydown.enter)="attemptToLogin(loginForm)"
              class="form-control input-underline" placeholder="PASSWORD" required>
          </show-hide-password>
        </div>
        <div class="error">
          {{error?.message}}
        </div>
        <div *ngIf="!forgotPass" class="d-flex justify-content-between py-1">
          <div class="small-text remember-me">
            <input type="checkbox" name="remember" [(ngModel)]="rememberMe" class="box" /><span>Remember me</span>
          </div>
          <div>
            <a class="small-text pointer forgot-password">
              <span (click)="forgotPass = true">Forgot Password<i class="fa fa-question-circle space"></i></span>
            </a>
          </div>
        </div>
        
        <br>
        <div *ngIf="!forgotPass" class="row col-12">
          <div class="col-lg-12 button">
            <p class="textbutton pointer button-bottom" (click)="attemptToLogin(loginForm)">
              Login</p>
          </div>
          <!--div class="col-lg-6 button">
            <p class="textbutton pointer button-bottom" (click)="logout()">Register</p>
          </div-->
        </div>
        <div *ngIf="forgotPass" class="row col-12">
          <div class="col-lg-6 button">
            <p class="textbutton pointer button-bottom" (click)="sendToken(loginForm)">
              Send token</p>
          </div>
          <div class="col-lg-6 button">
            <p class="textbutton pointer button-bottom" (click)="resetPass = true">
              Reset Password</p>
          </div>
          <div class="col-lg-12">
            <p class="small-text mt-4 border-bottom pb-1 pointer" (click)="forgotPass = false">
              Return to login</p>
          </div>
        </div>
      </form>
      <form *ngIf="resetPass" #resetPassForm="ngForm" name="resetForm">
        <div class="form-group pb-3">
          <input #token="ngModel" ngModel name="token" type="text" class="form-control input-underline"
            aria-describedby="emailHelp" placeholder="TOKEN" required>
        </div>
        <div class="form-group pb-3">
          <show-hide-password icon="fa fa-eye-slash" class="inputbotom">
            <input #userPassword="ngModel" ngModel name="userPassword" type="password"
              class="form-control input-underline" placeholder="NEW PASSWORD" required>
          </show-hide-password>
        </div>
        <div class="error">
          {{error?.message}}
        </div>
        <br>
        <div class="row col-12">
          <div class="col-lg-6 button">
            <p class="textbutton pointer button-bottom" (click)="resetPassword(resetPassForm)">
              Reset Password</p>
          </div>
          <div class="col-lg-12">
            <p class="small-text mt-4 border-bottom pb-1 pointer" (click)="forgotPass = false; resetPass = false">
              Return to login</p>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>